import { AddCircleOutlined, OpenInNew } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { useIsMobile } from '@side/pantry';
import { AnalyticsEvent, useTrackEvent } from '$analytics';
import { RequestNewButton } from '../AccountSettingsAddTeamMemberCard/RequestNewButton';

/**
 * NOTE: Moved to it's own component since it is reused
 * between the page and the loading skeleton
 */
export function AccountSettingsTeamPermissionsHeader() {
  const isMobile = useIsMobile('md');
  const trackEvent = useTrackEvent();
  return (
    <Stack
      sx={{
        flexDirection: isMobile ? 'column' : 'row',
        p: isMobile ? 2 : 3,
        gap: isMobile ? 2 : 3,
      }}
    >
      <Stack sx={{ flexDirection: 'column', flexGrow: 1, gap: 1 }}>
        <Typography variant={isMobile ? 'h2' : 'h1'} component="span">
          Team Management
        </Typography>
        <Stack
          direction="row"
          sx={{
            gap: 1,
            flexWrap: 'wrap',
          }}
        >
          <Typography
            variant={isMobile ? 'body2' : 'body1'}
            sx={{
              color: 'text.secondary',
              display: 'inline-flex',
            }}
          >
            Manage team members or request to add a new one
          </Typography>
          <Button
            endIcon={<OpenInNew />}
            variant="link"
            size="small"
            sx={{
              display: 'inline-flex',
            }}
            href="https://drive.google.com/file/d/1WnVSXPHCJBm4ofusEL3iq9xzVcr_Clsp/view?usp=sharing"
            target="_blank"
            rel="noopener"
            onClick={() => {
              trackEvent(
                AnalyticsEvent.AddTeamMemberCardOnboardingChecklistClick,
              );
            }}
          >
            Onboarding checklist
          </Button>
        </Stack>
      </Stack>
      <Stack
        sx={{
          flexDirection: 'row',
          gap: 2,
          my: 'auto',
        }}
      >
        <RequestNewButton
          variant="contained"
          startIcon={<AddCircleOutlined />}
          fullWidth={isMobile}
          sx={{
            textWrap: 'nowrap',
          }}
          color="primary"
        >
          Request New
        </RequestNewButton>
      </Stack>
    </Stack>
  );
}
